import { useLingui } from '@lingui/react/macro';
import { Button } from '@utima/ui';
import { Trash2 } from 'lucide-react';
import { memo, useState, type ReactNode } from 'react';

import { ConfirmDialog } from '@/components/confirmDialog/ConfirmDialog';
import { SimpleTooltip } from '@/components/tooltips/simple-tooltip';

import { ActionsCellWrapper } from './ActionsCellWrapper';

export type ActionsCellProps = {
  onDelete?: () => Promise<unknown> | unknown;
  children?: ReactNode;
  deleteDescription?: string;
  confirmationText?: string;
  confirmationLabel?: string;
};

export const ActionsCell = memo(function ActionsCell({
  children,
  onDelete,
  deleteDescription,
  confirmationText,
  confirmationLabel,
}: ActionsCellProps) {
  const { t } = useLingui();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <ConfirmDialog
        open={opened}
        onConfirm={onDelete}
        onOpenChange={(open: boolean) => setOpened(open)}
        description={deleteDescription}
        confirmationText={confirmationText}
        confirmationLabel={confirmationLabel}
      />

      <ActionsCellWrapper>
        {children}
        {onDelete && (
          <SimpleTooltip title={t`Delete`}>
            <Button
              size='icon-xs'
              variant='ghost'
              className='text-danger'
              outline
              onClick={() => setOpened(true)}
            >
              <Trash2 className='size-4' />
            </Button>
          </SimpleTooltip>
        )}
      </ActionsCellWrapper>
    </>
  );
});
